import { USERINPUTTYPE } from "../userinput/internal";
import { Tool } from "./internal";
/**
 * The Selectionmodel-Type-Enum.
 * @enum {number}
 */
export var SELECTIONMODEL;
(function (SELECTIONMODEL) {
    SELECTIONMODEL[SELECTIONMODEL["SINGLE"] = 0] = "SINGLE";
    SELECTIONMODEL[SELECTIONMODEL["SIMPLE"] = 1] = "SIMPLE";
    SELECTIONMODEL[SELECTIONMODEL["MULTI"] = 2] = "MULTI";
})(SELECTIONMODEL || (SELECTIONMODEL = {}));
/**
 * A class to select features.
 *
 * @class SelectFeatureTool
 * @author Eric Matti, Joel Burkhard
 * @extends {Tool}
 */
export class SelectFeatureTool extends Tool {
    constructor(scene, toolhandler, options, name, group) {
        super(scene, toolhandler);
        this.singleActive = false;
        this._selectinputevent = null;
        this._deselectinputevent = null;
        this._resetinputevent = null;
        this._mousemoveevent = null;
        this._hoveredfeature = null;
        this.name = name;
        this.group = group;
        // options, set the default values here
        const defaultoptions = {
            selectinput: USERINPUTTYPE.MOUSEUP,
            resetinput: null, //USERINPUTTYPE.RIGHTCLICK, this has problems if measure and draw is finished with the same button
            deselectinput: USERINPUTTYPE.MOUSEUP,
            selectedcbf: null,
            deselectedcbf: null,
            onovercbf: null,
            onoutcbf: null,
            enablecbf: null,
            disablecbf: null,
            resetcbf: null,
            clearcbf: null,
            cbobject: null,
            activecursor: "default",
            picklayer: [],
            hightlightonhover: true,
            singleactive: false,
            uniqueactive: true,
            selectionmodel: SELECTIONMODEL.MULTI,
            clearonnullpick: false,
        };
        for (const property in defaultoptions) {
            this.options[property] = defaultoptions[property];
        }
        super.parseOptions(options);
        this.type = "SelectFeatureTool";
    }
    /**
     * Internal function, to activate tool call SelectFeatureTool.enable.
     * @method _enableTool
     * @protected
     * @return {void}
     */
    _enableTool() {
        this._subscribeEvents();
        this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
        this.fire(SelectFeatureTool.enabled, this.options["cbobject"]);
    }
    /**
     * Internal function, to disable tool call mmSelectFeatureTool.disable.
     * @method _disableTool
     * @protected
     * @return {void}
     */
    _disableTool() {
        if (!this.enabled) {
            return;
        }
        this.fire(SelectFeatureTool.disabled, this.options["cbobject"]);
        this._unSubscribeEvents();
        this.reset();
        this.scene.getCursorStyleHandler().setCursorStyle("default");
        this.scene.infrascene.render();
    }
    _subscribeEvents() {
        if (this.options.selectinput !== null) {
            if (this.options.deselectinput == null || this.options.deselectinput == this.options.selectinput) {
                this._selectinputevent = this.scene.userInputHandler.subscribeEvent(this.options.selectinput, this._selectdeselectfeature, this);
            }
            else {
                this._selectinputevent = this.scene.userInputHandler.subscribeEvent(this.options.selectinput, this._selectfeature, this);
            }
        }
        if (this.options.deselectinput !== null && this.options.deselectinput !== this.options.selectinput) {
            this._deselectinputevent = this.scene.userInputHandler.subscribeEvent(this.options.deselectinput, this._deselectfeature, this);
        }
        if (this.options.resetinput !== null) {
            this._resetinputevent = this.scene.userInputHandler.subscribeEvent(this.options.resetinput, this.reset, this);
        }
        if (this.options.hightlightonhover !== null) {
            this._mousemoveevent = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._hoverFeature, this);
        }
        if (this.options.enablecbf != null) {
            this.on(SelectFeatureTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.on(SelectFeatureTool.disabled, this.options.disablecbf);
        }
        if (this.options.selectedcbf != null) {
            this.on(SelectFeatureTool.selected, this.options.selectedcbf);
        }
        if (this.options.deselectedcbf != null) {
            this.on(SelectFeatureTool.deselected, this.options.deselectedcbf);
        }
        if (this.options.onovercbf != null) {
            this.on(SelectFeatureTool.onover, this.options.onovercbf);
        }
        if (this.options.onoutcbf != null) {
            this.on(SelectFeatureTool.onout, this.options.onoutcbf);
        }
        if (this.options.resetcbf != null) {
            this.on(SelectFeatureTool.reset, this.options.resetcbf);
        }
        if (this.options.clearcbf != null) {
            this.on(SelectFeatureTool.clear, this.options.clearcbf);
        }
    }
    _unSubscribeEvents() {
        this.scene.userInputHandler.unSubscribeEvent(this.options.resetinput, this._resetinputevent);
        this._resetinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.selectinput, this._selectinputevent);
        this._selectinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.deselectinput, this._deselectinputevent);
        this._deselectinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._mousemoveevent);
        this._mousemoveevent = null;
        if (this.options.enablecbf != null) {
            this.off(SelectFeatureTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.off(SelectFeatureTool.disabled, this.options.disablecbf);
        }
        if (this.options.selectedcbf != null) {
            this.off(SelectFeatureTool.selected, this.options.selectedcbf);
        }
        if (this.options.deselectedcbf != null) {
            this.off(SelectFeatureTool.deselected, this.options.deselectedcbf);
        }
        if (this.options.onovercbf != null) {
            this.off(SelectFeatureTool.onover, this.options.onovercbf);
        }
        if (this.options.onoutcbf != null) {
            this.off(SelectFeatureTool.onout, this.options.onoutcbf);
        }
        if (this.options.resetcbf != null) {
            this.off(SelectFeatureTool.reset, this.options.resetcbf);
        }
        if (this.options.clearcbf != null) {
            this.off(SelectFeatureTool.clear, this.options.clearcbf);
        }
    }
    /**
     * Function is fired on the selectinputevent
     * @method _selectfeature
     * @param {any} evt Event from userInputHandler
     * @private
     * @return {void}
     */
    _selectfeature(evt) {
        if ((this.options.selectinput !== USERINPUTTYPE.MOUSEUP || evt.button == 0) && !evt.isDragging) {
            const pickdataarray = this.scene.getFeatureHandler().pick(evt.offsetX, evt.offsetY, this.options.picklayer);
            if (pickdataarray !== null) {
                const feature = pickdataarray[0].feature;
                if (!feature.isselected) {
                    if (!this._keepExisting(evt)) {
                        this.clear(evt);
                    }
                    this.fire(SelectFeatureTool.selected, this.options["cbobject"], feature, evt);
                }
            }
            else {
                if (this.options.clearonnullpick)
                    this.clear(evt);
            }
        }
    }
    /**
     * Function is fired on the selectinputevent
     * @method _selectfeature
     * @param {any} evt Event from userInputHandler
     * @private
     * @return {void}
     */
    _selectdeselectfeature(evt) {
        if ((this.options.selectinput !== USERINPUTTYPE.MOUSEUP || evt.button == 0) && !evt.isDragging) {
            const pickdataarray = this.scene.getFeatureHandler().pick(evt.offsetX, evt.offsetY, this.options.picklayer);
            if (pickdataarray !== null) {
                const feature = pickdataarray[0].feature;
                const keepexisting = this._keepExisting(evt);
                if (feature.isselected) {
                    if (keepexisting) {
                        this.fire(SelectFeatureTool.deselected, this.options["cbobject"], feature, evt);
                    }
                    else {
                        this.clear(evt);
                        this.fire(SelectFeatureTool.selected, this.options["cbobject"], feature, evt);
                    }
                }
                else {
                    if (!this._keepExisting(evt)) {
                        this.clear(evt);
                    }
                    this.fire(SelectFeatureTool.selected, this.options["cbobject"], feature, evt);
                }
            }
            else {
                if (this.options.clearonnullpick)
                    this.clear(evt);
            }
        }
    }
    /**
     * Function is fired on the deselectinputevent
     * @method _selectfeature
     * @param {any} evt Event from userInputHandler
     * @private
     * @return {void}
     */
    _deselectfeature(evt) {
        if ((this.options.selectinput !== USERINPUTTYPE.MOUSEUP || evt.button == 0) && !evt.isDragging) {
            const pickdataarray = this.scene.getFeatureHandler().pick(evt.offsetX, evt.offsetY, this.options.picklayer);
            if (pickdataarray !== null) {
                const feature = pickdataarray[0].feature;
                if (feature.isselected) {
                    this.fire(SelectFeatureTool.deselected, this.options["cbobject"], feature, evt);
                }
            }
        }
    }
    /**
     * Function is fired on the mousemoveevent
     * @method _selectfeature
     * @param {any} evt Event from userInputHandler
     * @private
     * @return {void}
     */
    _hoverFeature(evt) {
        // helpers
        const over = (feature) => {
            this._hoveredfeature = feature;
            if (this.options.hightlightonhover && !this._hoveredfeature.isselected) {
                this._hoveredfeature.highlightOn();
            }
            this.fire(SelectFeatureTool.onover, this.options["cbobject"], this._hoveredfeature, evt);
        };
        const out = () => {
            if (this.options.hightlightonhover && !this._hoveredfeature.isselected) {
                this._hoveredfeature.highlightOff();
            }
            this.fire(SelectFeatureTool.onout, this.options["cbobject"], this._hoveredfeature, evt);
            this._hoveredfeature = null;
        };
        // main
        const pickdataarray = this.scene.getFeatureHandler().pick(evt.offsetX, evt.offsetY, this.options.picklayer);
        if (pickdataarray !== null) {
            const feature = pickdataarray[0].feature;
            if (this._hoveredfeature == null) {
                over(feature);
            }
            else if (this._hoveredfeature.id !== feature.id) {
                out();
                over(feature);
            }
        }
        else if (this._hoveredfeature !== null) {
            out();
        }
    }
    /**
     * Deselects all features and releases the aborted callback.
     * @method reset
     * @param {any} evt Event from userInputHandler
     * @public
     * @return {void}
     */
    reset(evt) {
        if (this._hoveredfeature !== null && this.options.highlightOnHover)
            this._hoveredfeature.highlightOff();
        this._hoveredfeature = null;
        this.fire(SelectFeatureTool.reset, this.options["cbobject"], evt);
    }
    clear(evt) {
        this.fire(SelectFeatureTool.clear, this.options["cbobject"], evt);
    }
    /**
     * Add featurecollection to picklayer, only feature in this
     * option will be selected
     * @method addToPickLayer
     * @param {FeatureCollection} featurecollection Featurecollection to add to picklayer
     * @public
     * @return {void}
     */
    addToPickLayer(featurecollection) {
        this.options.picklayer.push(featurecollection);
    }
    /**
     * Remove featurecollection from picklayer
     * @method removeFromPickLayer
     * @param {FeatureCollection} featurecollection Featurecollection to remove from picklayer
     * @public
     * @return {void}
     */
    removeFromPickLayer(featurecollection) {
        const index = this.options.picklayer.indexOf(featurecollection);
        if (index > -1) {
            this.options.picklayer.splice(index, 1);
        }
    }
    _keepExisting(evt) {
        let keepExisting;
        switch (this.options.selectionmodel) {
            case SELECTIONMODEL.SINGLE:
                keepExisting = false;
                break;
            case SELECTIONMODEL.SIMPLE:
                keepExisting = true;
                break;
            case SELECTIONMODEL.MULTI:
                keepExisting = evt.ctrlKey;
                break;
        }
        return keepExisting;
    }
}
SelectFeatureTool.enabled = "enabled";
SelectFeatureTool.disabled = "disabled";
SelectFeatureTool.selected = "selected";
SelectFeatureTool.deselected = "deselected";
SelectFeatureTool.onover = "onover";
SelectFeatureTool.onout = "onout";
SelectFeatureTool.reset = "reset";
SelectFeatureTool.clear = "clear";
//# sourceMappingURL=selectfeaturetool.js.map